<template>
    <div class="gmf-vertical-separator">
        <div class="gmf-vertical-separator-line"></div>
        <div class="gmf-vertical-separator-text"><slot /></div>
        <div class="gmf-vertical-separator-line"></div>
    </div>
</template>

<style>
.gmf-context .gmf-vertical-separator {
  display: flex;
  gap: var(--gmf-p-3);
  align-items: center;
  color: var(--gmf-col-darkgray);
  font-size: var(--gmf-text-small-font-size);
}
.gmf-vertical-separator-line {
  border-top: 1px solid var(--gmf-col-gray);
  flex-grow: 1;
}
</style>